import { useContext } from 'react';
import { useIsDealershipPage } from '~/context/dealership/StaticContext';
import userVehicleContext from '~/context/vdp/UserVehicleContext';
import useIsNotAvailableForImmediatePurchase from './useIsNotAvailableForImmediatePurchase';

export default function useCanShowDeliveryAndPickupInfo() {
  const isDealership = useIsDealershipPage();
  const isNotPurchasable = useIsNotAvailableForImmediatePurchase();
  const { isLoaded } = useContext(userVehicleContext).vehicleAvailability;

  return !isDealership && !isNotPurchasable && isLoaded;
}
